import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

type DeleteJobNoteParams = {
  jobId: string;
  noteId: string;
};

export const useDeleteJobNoteMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, noteId }: DeleteJobNoteParams) => {
      await fetchClient.DELETE(endpoints.jobNote, {
        params: { path: { jobId, id: noteId } },
      });
    },
    onSettled: (_data, _error, { jobId }) => {
      invalidateQuery(jobsQueryKeys.notes(jobId))();
    },
  });
};
